"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.manualSaveView = void 0;
const model_1 = require("../../model");
const command_manager_1 = require("../../command_manager");
const store_1 = require("../../exports/store");
const types_1 = require("../../types");
exports.manualSaveView = {
    undoable: false,
    execute: (context, options) => {
        const { model: state, fieldMapSnapshot } = context;
        const { viewProperty, viewId } = options;
        const datasheetId = store_1.Selectors.getActiveDatasheetId(state);
        const snapshot = store_1.Selectors.getSnapshot(state, datasheetId);
        if (!snapshot) {
            return null;
        }
        const manualSaveViewActions = model_1.DatasheetActions.manualSaveView2Action(snapshot, { viewId, viewProperty });
        if (!manualSaveViewActions) {
            return null;
        }
        const actions = [...manualSaveViewActions];
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
            fieldMapSnapshot
        };
    },
};
//# sourceMappingURL=manual_save_view.js.map